/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_Information_QualityInputs */

const en_directory_score_information_quality = /** @type {(inputs: Directory_Score_Information_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information quality`)
};

const zh_directory_score_information_quality = /** @type {(inputs: Directory_Score_Information_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息质量`)
};

/**
* | output |
* | --- |
* | "Information quality" |
*
* @param {Directory_Score_Information_QualityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_information_quality = /** @type {((inputs?: Directory_Score_Information_QualityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_Information_QualityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_information_quality(inputs)
	return zh_directory_score_information_quality(inputs)
});
export { directory_score_information_quality as "directory.score.information_quality" }